import useMarkProposalAsAccepted from '@/api/mutations/proposals/useMarkProposalAsAccepted';
import ProposalConfirmationModal from '@/ui/pages/proposalBuilderPage/components/proposalLifecycleActions/ProposalConfirmationModal';
import { ModalProps, Text, useToastContext } from '@payaca/ambrosia';
import { FC } from 'react';

type MarkProposalAsAcceptedModalProps = {
  proposalId: string;
  projectId: string;
  /** Whether the Proposal asks the Customer for a deposit. */
  hasDeposit: boolean;
} & Omit<ModalProps, 'title'>;

const MarkProposalAsAcceptedModal: FC<MarkProposalAsAcceptedModalProps> = (
  props
) => {
  const { proposalId, projectId, hasDeposit, onClose, ...rest } = props;
  const { pushSuccess } = useToastContext();

  const { mutate, isPending } = useMarkProposalAsAccepted({
    proposalId,
    projectId,
    options: {
      onSuccess: () => {
        pushSuccess('Proposal marked as accepted.');
        onClose?.();
      },
    },
  });

  return (
    <ProposalConfirmationModal
      {...rest}
      onClose={onClose}
      title="Mark as accepted"
      confirmLabel="Mark as accepted"
      isPending={isPending}
      onConfirm={() => mutate({ id: proposalId })}
    >
      <Text>
        This records the customer&apos;s acceptance without asking them to sign,
        and runs your acceptance automations.
      </Text>
      {hasDeposit && (
        <Text>
          If a deposit is due, a deposit invoice is raised and emailed to the
          customer.
        </Text>
      )}
    </ProposalConfirmationModal>
  );
};

export default MarkProposalAsAcceptedModal;
